import { SET_WORKOUT_PLANS, SET_WORKOUT_PLAN_BY_ID, RESET_WORKOUT_PLAN_BY_ID, RESET_WORKOUT_PLANS } from './workoutPlanTypes';

export const setWorkoutPlans = (data) => ({
	type: SET_WORKOUT_PLANS,
	payload: data,
});

export const setWorkoutPlanById = (data) => ({
	type: SET_WORKOUT_PLAN_BY_ID,
	payload: data,
});

export const resetWorkoutPlanById = () => ({
	type: RESET_WORKOUT_PLAN_BY_ID,
});

export const resetWorkoutPlans = () => ({
	type: RESET_WORKOUT_PLANS,
});
